export default () => (
  /**
   * Ícone para minimizar imagem em modal de camada tipo 'jpg/jpeg'
   */
  <svg 
    width="12" 
    height="12" 
    viewBox="0 0 12 12" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M5.18751 1.38281H1.66016V10.6109H10.8921V7.06104" 
      stroke="#C3C3C9" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M6.35719 2.67355L6.35719 5.88281M6.35719 5.88281L9.38828 5.88281M6.35719 5.88281L10.9102 1.32984" 
      stroke="#C3C3C9" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
  
);
